var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background-color":"#0b7078ff"},attrs:{"theme":"light"}},[_c('nav-bar-vuetify'),_c('VMain',[_c('router-view',{staticClass:"secondary--text"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }